import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=8925c2ea"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"
import style0 from "./AccountEdit.vue?vue&type=style&index=0&id=8925c2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports